<template>
  <b-table :fields="propFields"
           :items="propItems"
           outlined
           striped
           :busy="propBusy"
           class="text-center table-hover"
           thead-class="PapelSegurancaRelatorios_table--header"
           tbody-tr-class="thead-row-class"
           show-empty>
    <template #table-busy>
      <div class="text-center text-info my-2">
        <b-spinner class="align-middle mr-2 icon--sm" />
        <strong>Carregando...</strong>
      </div>
    </template>
    <template v-slot:empty="scope">
      <div class="text-center">
        Sem registros
      </div>
    </template>
    <template slot="key_data_consumo"
              slot-scope="data">
      <div class="text-left pointer mt-1">
        {{ data.item.data_consumo | date }}
      </div>
    </template>
    <template slot="key_impresso_seguranca"
              slot-scope="data">
      <div class="text-left pointer mt-1">
        {{ data.item.impresso_seguranca }}
      </div>
    </template>
    <template slot="key_nome_solicitante"
              slot-scope="data">
      <div class="text-left pointer mt-1">
        {{ data.item.nome_solicitante }}
      </div>
    </template>
    <template slot="key_nome_usuario"
              slot-scope="data">
      <div class="text-left pointer mt-1">
        {{ data.item.nome_usuario }}
      </div>
    </template>
    <template slot="key_mais_detalhes"
              slot-scope="data">
      <div class="d-flex">
        <b-button variant="outline-primary"
                  @click="goToReportsDetails(data.item)">
          Acessar detalhes
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
  export default {
    name: 'ReportsTable',
    props: {
      propFields: { type: Array, default: () => []},
      propItems: { type: Array, default: () => []},
      propBusy: { type: Boolean, default: () => false}
    },
    methods: {
      goToReportsDetails (data) {
        this.$emit('sendingDataToTheModal', {data})
        this.$bvModal.show('reports_details')
      },
    }
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/_exports';

.PapelSegurancaRelatorios {
    &_table {
      &--header {
        background-color: #01bfa5;
        white-space: nowrap;
        text-align: start;
      }
    }
}
</style>
